import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M2.095 2.094a.75.75 0 0 1 1.06 0L12 10.938l8.845-8.844a.75.75 0 0 1 .976-.073l.084.073a.75.75 0 0 1 0 1.06L13.061 12l8.844 8.845a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0L12 13.06l-8.845 8.844a.75.75 0 0 1-.976.073l-.084-.073a.75.75 0 0 1 0-1.06l8.844-8.845-8.844-8.845a.75.75 0 0 1-.073-.976l.073-.084z' />
  </svg>
);
